export const EXPAND_CONTROL_PROPS = {
  defaultExpanded: false,
  iconButtonProps: { disabled: true, size: "small", sx: { fontSize: "10px" } },
} as const;
